// extracted by mini-css-extract-plugin
export default {"container":"backgroundSelectFilter_container__t3eED","icon":"backgroundSelectFilter_icon__mUwGf","copy":"backgroundSelectFilter_copy__XODXl"};